///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching = abcsetup.new_customer_matching || {};
abcsetup.new_customer_matching.events = abcsetup.new_customer_matching.events || {};
abcsetup.new_customer_matching.events.matches = abcsetup.new_customer_matching.events.matches || {};
abcsetup.new_customer_matching.events.matches.non_carried_items = abcsetup.new_customer_matching.events.matches.non_carried_items || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching.events.matches.non_carried_items = {
    init: function() {
        /* Auto open the Non-Carried Items modal. */
        $(document).ready(function(e) {
            if ($('#has_non_carried') && $('#has_non_carried').val() == 'true') {
                $('#non-carried-item-modal').modal('show');
            }
        });

        /* Listen & handle for Supplier Submissions for NCM non-carried Item */
        $('.uncarried-item-submit').on('click', function(e) {
            const ncm_item_id = $(this).data('id');
            const tab_id = $(this).data('tab_id');

            if (
                $(`#unci-${ncm_item_id}-product_description`).val() == null || $(`#unci-${ncm_item_id}-product_description`).val() == '' ||
                $(`#unci-${ncm_item_id}-wac`).val() == null || $(`#unci-${ncm_item_id}-wac`).val() == '' ||
                $(`#unci-${ncm_item_id}-pkg_size`).val() == null || $(`#unci-${ncm_item_id}-pkg_size`).val() == ''
            ) {
                abcsetup.alerts.show('Can not continue.', 'Please fill out all required fields.');
                return;
            }

            abcsetup.alerts.confirm(
                'Item Confirmation',
                `Are you sure you can supply the item the category manager requested? If yes, after you submit the form fields, you may continue to your workflow task.`,
                function(resp) {
                    if (resp) {
                        abcsetup.blockUI(true);

                        axios.put(`/api/new_customer_matching/uncarried_items/${ncm_item_id}/update`, {
                            product_description: $(`#unci-${ncm_item_id}-product_description`).val(),
                            wac: $(`#unci-${ncm_item_id}-wac`).val(),
                            upc: $(`#unci-${ncm_item_id}-upc`).val(),
                            ndc: $(`#unci-${ncm_item_id}-ndc`).val(),
                            mfr_part_num: $(`#unci-${ncm_item_id}-mfr_part_num`).val(),
                            pkg_size: $(`#unci-${ncm_item_id}-pkg_size`).val(),
                            contract_price: $(`#unci-${ncm_item_id}-contract_price`).val(),
                            comments: $(`#unci-${ncm_item_id}-comments`).val(),
                            form_action: 'update'
                        })
                        .then(response => {
                            const data = response.data;

                            if (data.success && data.message) {
                                let next_tab = new Number(tab_id) + 1;

                                if (data.uncarried_item_partial != null) {
                                    document.getElementById('additional-items-list').innerHTML = data.uncarried_item_partial;
                                }

                                abcsetup.unblockUI();
                                abcsetup.alerts.show('Success', data.message);

                                /* Reload the data table for the workflow task. */
                                window.LaravelDataTables['app_data_tables_new_customer_matching_item_match_data_table'].ajax.reload();

                                /* If there are more items to update, remove the told tabs & display the new tab active. */
                                if ($(`#item-${next_tab}-tab-link`) && $(`#item-${tab_id}-tab`)) {
                                    abcsetup.new_customer_matching.events.matches.non_carried_items.swapTab(tab_id, next_tab);
                                }

                                if (data.completed && data.completed == true) {
                                    $('#non-carried-item-modal').modal('hide');
                                }
                            } else {
                                abcsetup.unblockUI();
                                abcsetup.alerts.show(
                                    'Something went wrong',
                                    `Something went wrong trying to update this item. Please try again later. ${JSON.stringify(response.data)}`
                                );
                            }
                        })
                        .catch(error => {
                            abcsetup.unblockUI();
                            console.error(error);
                            abcsetup.alerts.show(
                                'Something went wrong',
                                `Something went wrong trying to update this item. Please try again later. ${error.response.data.message}`
                            );
                        });
                    }
                }
            )
        });

        $('.uncarried-item-reject-btn').on('click', function(e) {
            const ncm_item_id = $(this).data('id');
            const tab_id = $(this).data('tab_id');

            if (!$('#unci-'+tab_id+'-reject_reason').val()) {
                abcsetup.unblockUI();
                abcsetup.alerts.show('No rejection reason.', 'Please fill out the reason for declining this item.');
                return;
            }

            abcsetup.alerts.confirm(
                'Item Decline Confirmation',
                `Are you sure you do not manufacture the item requested by the Category Manager and can not supply it for this Event?`,
                function(resp) {
                    if (resp) {
                        abcsetup.blockUI(true);

                        axios.put(`/api/new_customer_matching/uncarried_items/${ncm_item_id}/update`, {
                            form_action: 'decline',
                            reject_reason: $('#unci-'+tab_id+'-reject_reason').val(),
                        })
                        .then(response => {
                            abcsetup.unblockUI();
                            const data = response.data;

                            if (data.success && data.message) {
                                let next_tab = new Number(tab_id) + 1;
                                abcsetup.alerts.show('Success', data.message);
                                abcsetup.new_customer_matching.events.matches.non_carried_items.swapTab(tab_id, next_tab);

                                if (data.completed && data.completed == true) {
                                    /* refresh table to clear empty rows */
                                    window.LaravelDataTables['app_data_tables_new_customer_matching_item_match_data_table'].ajax.reload();
                                    $('#non-carried-item-modal').modal('hide');

                                    if (data.can_submit_non_carried_items != true) {
                                        $('#non_carried_item_modal_btn').hide();
                                    }
                                }
                            } else {
                                abcsetup.alerts.show(
                                    'Something went wrong',
                                    `${data.message}. ${JSON.stringify(response.data)}`
                                );
                            }
                        })
                        .catch(error => {
                            abcsetup.unblockUI();
                            console.error(error);
                            abcsetup.alerts.show(
                                'Something went wrong',
                                `Something went wrong trying to update this "un-carried" item. Please try again later. ${error.response.data.message}`
                            );
                        });
                    }
                }
            );
        });

        $('.supplier-submits-uncarried-item').on('click', function(e) {
            if (
                $('#unci-new-product_description').val() == null || $('#unci-new-product_description').val() == '' ||
                $(`#unci-new-wac`).val() == null || $(`#unci-new-wac`).val() == '' ||
                $(`#unci-new-pkg_size`).val() == null || $(`#unci-new-pkg_size`).val() == ''
            ) {
                abcsetup.alerts.show('Can not continue.', 'Please fill out all required fields.');
                return;
            }

            if (Number($(`#unci-new-current_bid`).val()) > Number($(`#unci-new-wac`).val())) {
                $(`#unci-new-wac`).addClass('error-border');
                $(`#unci-new-current_bid`).addClass('error-border');

                abcsetup.alerts.show('Can not continue.', 'The Offer Price must be less than or equal to the WAC price.');
                return;
            } else {
                $(`#unci-new-wac`).removeClass('error-border').addClass('success-border');
                $(`#unci-new-current_bid`).removeClass('error-border').addClass('success-border');
            }

            abcsetup.alerts.confirm(
                'Item Confirmation',
                `Are you sure you can supply this item? This item will be added to the event and will need to be reviewed by the Category Manager.`,
                function(resp) {
                    if (resp) {
                        abcsetup.blockUI(true);

                        axios.post('/api/new_customer_matching/uncarried_items/store', {
                            cm_role_id: $('#uncarried_item_cm_role_id').val(),
                            new_customer_matching_event_id: $('#new_customer_matching_event_id').val(),
                            product_description: $(`#unci-new-product_description`).val(),
                            wac: $(`#unci-new-wac`).val(),
                            upc: $(`#unci-new-upc`).val(),
                            ndc: $(`#unci-new-ndc`).val(),
                            mfr_part_num: $(`#unci-new-mfr_part_num`).val(),
                            pkg_size: $(`#unci-new-pkg_size`).val(),
                            contract_price: $(`#unci-new-contract_price`).val(),
                            comments: $(`#unci-new-comments`).val(),
                            form_action: 'submit',
                            current_bid: $('#unci-new-current_bid').val(),
                        })
                        .then(response => {
                            const data = response.data;

                            if (data.success && data.message) {
                                abcsetup.unblockUI();

                                $('#supplier_submits_non_carried_items').modal('hide');
                                abcsetup.alerts.show("Additional Item Submitted", data.message);

                                /* clear values for another additional uncarried item to be submitted */
                                $('input[id^="unci-new"]').each(function() {
                                    $(this).val(null);
                                });

                                /* we do not refresh the datatable here because the item needs to be approved by the CM before the Supplier
                                can submit an offer */
                            }
                        })
                        .catch(error => {
                            abcsetup.unblockUI();
                            console.error(error);
                            abcsetup.alerts.show(
                                'Something went wrong',
                                `Something went wrong trying to submit this additional item to the Category Manager. Please try again later. ${error.response.data.message}`
                            );
                        });
                    }
                }
            )
        });
    },

    swapTab(tab_id, next_tab_id) {
        $(`#item-${tab_id}-tab-link`).remove();
        $(`#item-${tab_id}-tab`).remove();
        $(`#item-${next_tab_id}-tab-link`).addClass('active');
        $(`#item-${next_tab_id}-tab`).addClass('active').addClass('show');
    }
}